module.exports = __webpack_public_path__ + "img/obifi-logo.d8079375.svg";